import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';

@Component({
  selector: 'app-camera-corners',
  templateUrl: './camera-corners.component.html',
  styleUrls: ['./camera-corners.component.scss']
})
export class CameraCornersComponent implements OnInit, AfterViewInit {

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

}
